import { createFileRoute } from '@tanstack/react-router';
import { CheckinsPage } from '@pages/checkins';

/** Check-in-Verlauf-Route (/checkins) */
export const Route = createFileRoute('/_authenticated/checkins/')({
  component: CheckinsPage,
});
